import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import { Grid, Paper, Button, Typography, Chip, TextEditor } from "../../../../";
import TodayIcon from "@material-ui/icons/Today";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
var useStyles = makeStyles(function (theme) {
  var _leftMain;

  return {
    done: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    doing: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    pending: {
      background: "#b7b6b682",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    critical: {
      background: "#FC5F15",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    outOfDate: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    leftMain: (_leftMain = {}, _defineProperty(_leftMain, theme.breakpoints.up("md"), {
      boxShadow: "15px 0 15px -5px #333"
    }), _defineProperty(_leftMain, "padding", "24px"), _leftMain),
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "10px",
      "margin-top": "10px"
    },
    subHeader: {
      display: "flex",
      justifyContent: "space-between",
      "align-items": "center",
      padding: "10px"
    },
    date: {
      display: "flex",
      "align-items": "center"
    },
    deadline: {
      "margin-left": "10px"
    },
    dataContact: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    icon: {
      width: "80px",
      height: "auto"
    },
    contact: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      background: "#ededed45",
      borderRadius: "4px"
    },
    actionsContact: {
      display: "flex",
      justifyContent: "flex-end"
    },
    infoContact: {
      margin: "10px",
      display: "flex",
      "flex-direction": "column",
      "align-items": "left"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    p10: {
      padding: "10px"
    }
  };
});

var TaskDetailInfo = function TaskDetailInfo(props) {
  var classes = useStyles();
  var task = props.task,
      titles = props.titles,
      translation = props.translation; // console.log("details info translation", translation);

  var momentDateFinalCheck = moment().add(7, "days");
  var momentDateCurrentCheck = moment();

  var getTypeState = function getTypeState(status, date) {
    var contentButton;

    if (status === "pending" || status === "doing") {
      if (moment(date).isBetween(momentDateCurrentCheck, momentDateFinalCheck)) {
        status += "_critical";
      }

      if (momentDateCurrentCheck.isAfter(moment(date))) {
        status = "out_of_date";
      }
    }

    switch (status) {
      case "pending":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation && translation.task_states ? translation.task_states[status].label : "Pending",
          className: classes.pending
        });
        break;

      case "doing":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation && translation.task_states ? translation.task_states[status].label : "Doing",
          className: classes.doing
        });
        break;

      case "done":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation && translation.task_states ? translation.task_states[status].label : "Done",
          className: classes.done
        });
        break;

      case "pending_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation ? translation.task_states.pending.label : "Pending",
          className: classes.critical
        });
        break;

      case "doing_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation ? translation.task_states.doing.label : "Doing",
          className: classes.critical
        });
        break;

      case "out_of_date":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          label: translation ? translation.task_states.out_of_date.label : "Out of date",
          className: classes.outOfDate
        });
        break;

      default:
        break;
    } // console.log("status", status);


    return contentButton;
  };

  var getButtonActionInfo = function getButtonActionInfo(state, key) {
    var labelButton;
    var disabledButton;
    var onClick; // console.log("state", state);

    switch (state) {
      case "pending":
        labelButton = translation ? translation.buttons.begin_task : "Begin task";
        disabledButton = false;

        onClick = function onClick() {
          props.handleButtonActionTask("pending", key);
        };

        break;

      case "doing":
        labelButton = translation ? translation.buttons.complete_task : "Complete task";
        disabledButton = props.disabledButton || false;

        onClick = function onClick() {
          props.handleButtonActionTask("doing", key);
        };

        break;

      case "done":
        labelButton = translation ? translation.buttons.completed_task : "Completed task";
        disabledButton = true;
        break;

      default:
        labelButton = state;
        disabledButton = false;
        break;
    }

    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.subHeader
    }, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      color: "primary",
      variant: "outlined",
      disabled: disabledButton,
      onClick: onClick
    }, labelButton));
  };

  var getButtonActionRecurrencyInfo = function getButtonActionRecurrencyInfo(itemRecurrency, key) {
    var labelButton;
    var disabledButton;
    var onClick;

    switch (itemRecurrency.status) {
      case "pending":
        labelButton = translation ? translation.buttons.begin_task : "Begin task";
        disabledButton = false;

        onClick = function onClick(e) {
          props.handleButtonActionTaskRecurrency(itemRecurrency, key);
        };

        break;

      case "doing":
        labelButton = translation ? translation.buttons.complete_task : "Complete task";
        disabledButton = props.disabledButton || false;

        onClick = function onClick() {
          props.handleButtonActionTaskRecurrency(itemRecurrency, key);
        };

        break;

      case "done":
        labelButton = translation ? translation.buttons.completed_task : "Completed task";
        disabledButton = true;
        break;

      default:
        labelButton = itemRecurrency.status;
        disabledButton = false;
        break;
    }

    return /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.subHeader
    }, /*#__PURE__*/React.createElement(Button, {
      fullWidth: true,
      color: "primary",
      variant: "outlined",
      disabled: disabledButton,
      onClick: onClick
    }, labelButton));
  };

  var getTypeTask = function getTypeTask(task) {
    // console.log("task en getTypeTask", task);
    var contentHeader, contentSubHeader, contentButtonAction, contentDetails;
    var taskInfo;

    if (task.repeat) {
      var itemRecurrency = task.repeats.length > 0 ? task.repeats.find(function (_item) {
        return _item.status !== "done";
      }) || task.repeats[task.repeats.length - 1] : null;

      if (itemRecurrency) {
        taskInfo = _objectSpread({}, itemRecurrency);
        contentButtonAction = getButtonActionRecurrencyInfo(itemRecurrency, task.key);
      }
    } else {
      taskInfo = {
        date: task.date,
        status: task.status
      };
      contentButtonAction = getButtonActionInfo(task.status, task.key);
    } // console.log('taskInfo', taskInfo ? taskInfo : 'no hay')


    contentHeader = /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.header
    }, /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontWeight: "700"
      },
      variant: "h6"
    }, task.name), getTypeState(taskInfo && taskInfo.status, taskInfo && taskInfo.date));
    contentSubHeader = /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.subHeader
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.date
    }, /*#__PURE__*/React.createElement(Paper, {
      elevation: 0,
      className: classes.date
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, taskInfo && taskInfo.date ? [/*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(TodayIcon, null), /*#__PURE__*/React.createElement(Typography, {
      style: {
        fontWeight: "600"
      },
      variant: "subtitle1"
    }, translation ? translation.deadline : "Deadline")), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body2"
    }, moment(taskInfo.date).format("DD/MM/YYYY")))] : null))));
    contentDetails = /*#__PURE__*/React.createElement(Grid, {
      item: true,
      md: 12,
      className: classes.p10
    }, /*#__PURE__*/React.createElement(TextEditor, {
      value: task.details,
      mode: "view",
      toolbar: false
    }));
    return /*#__PURE__*/React.createElement(Grid, {
      container: true
    }, contentHeader, contentSubHeader, contentButtonAction, contentDetails);
  };

  return getTypeTask(task);
};

export { TaskDetailInfo };